export function normalizeTicketDetail(raw) {
  if (!raw) return null;
  const ticketData = { ...raw };
  ticketData.history =
    ticketData.TicketHistories ||
    ticketData.ticket_histories ||
    ticketData.history ||
    [];
  ticketData.comments =
    ticketData.TicketComments ||
    ticketData.ticket_comments ||
    ticketData.comments ||
    [];

  if (ticketData.reschedule_details) {
    try {
      ticketData.reschedule_details_parsed =
        typeof ticketData.reschedule_details === "string"
          ? JSON.parse(ticketData.reschedule_details)
          : ticketData.reschedule_details;
    } catch {
      ticketData.reschedule_details_parsed = null;
    }
  } else {
    ticketData.reschedule_details_parsed = null;
  }

  if ((ticketData.query_type || "").toUpperCase() === "RESCHEDULING") {
    const isClosed = ticketData.status === "Closed";
    const feeNotified = Number(ticketData.tbo_verified) === 1;
    const feeSet =
      ticketData.reschedule_fee != null &&
      String(ticketData.reschedule_fee).trim() !== "" &&
      Number.isFinite(Number(ticketData.reschedule_fee));
    const hasFlight = !!ticketData.reschedule_details_parsed;
    if (isClosed) ticketData.reschedule_status = "confirmed";
    else if (feeNotified) ticketData.reschedule_status = "fee_notified";
    else if (feeSet) ticketData.reschedule_status = "pending_fee";
    else if (hasFlight) ticketData.reschedule_status = "pending_flight_selection";
    else ticketData.reschedule_status = null;
  }

  return ticketData;
}
